import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Badge } from '@/components/ui/Badge';

export function FlipkartPageHeader({
  title,
  accountName,
  adAccountId,
}: {
  title: string;
  accountName: string;
  adAccountId: string;
}) {
  return (
    <header className="flex flex-wrap items-start gap-3">
      <Link
        to="/accounts"
        className="inline-flex shrink-0 items-center justify-center rounded-pill px-2 py-1.5 text-foreground-muted transition-colors hover:bg-surface-muted hover:text-foreground"
        aria-label="Back to accounts"
      >
        <ArrowLeft className="h-5 w-5" />
      </Link>
      <div className="min-w-0">
        <h1 className="text-headline-lg font-semibold text-foreground">{title}</h1>
        <div className="mt-1 flex flex-wrap items-center gap-2">
          <span className="text-body-md text-foreground-muted">Account: {accountName}</span>
          <Badge variant="neutral" className="normal-case tracking-normal font-medium">
            Flipkart
          </Badge>
          <span className="border-l border-border pl-2 font-mono text-body-sm text-foreground-muted">
            {adAccountId}
          </span>
        </div>
      </div>
    </header>
  );
}
